import { createAction } from '@reduxjs/toolkit';

export const requestViewTeamsForProgramme = createAction('programme-teams/viewTeamsForProgramme');
export const requestDownloadTeamExcel = createAction('programme-teams/requestDownloadTeamExcel');
export const requestUploadTeamExcel = createAction('programme-teams/requestUploadTeamExcel');
export const requestViewTeamLeaderboard = createAction('programme-teams/requestViewTeamLeaderboard');
